import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { ListInboundEmailsInput } from '@erp/rpc';

import { orpc } from '@/api/rpc/client';

export function useInboundEmails(
  params?: ListInboundEmailsInput,
  enabled = true,
) {
  return useQuery({
    ...orpc.communications.inboundEmails.list.queryOptions({
      input: params ?? {},
    }),
    enabled,
    placeholderData: keepPreviousData,
  });
}

/**
 * Resolve the inbound email (and conversation) that owns a document. Used to
 * detect docified email-body documents so a document viewer can pivot to the
 * smart email viewer. Pass `null` to disable the query.
 */
export function useInboundEmailByDocumentId(documentId: string | null) {
  return useQuery({
    ...orpc.communications.inboundEmails.getByDocumentId.queryOptions({
      input: { documentId: documentId ?? '' },
    }),
    enabled: !!documentId,
  });
}
